import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    audienceDetails: {},
    type: 'audience',
    list: [],
    audiencesActiveError: false,
    isLoading: false,
    collection: {},
    changeRowData: null,
    isUpdatedOrDeletedLoading: false,
    resetBulkSelectedRows: false
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
